import { render, staticRenderFns } from "./transfer-edit.vue?vue&type=template&id=c0220202&"
import script from "./transfer-edit.vue?vue&type=script&lang=js&"
export * from "./transfer-edit.vue?vue&type=script&lang=js&"
import style0 from "./transfer-edit.vue?vue&type=style&index=0&id=c0220202&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports